var parent = require('../stable/get-iterator-method');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/get-iterator-method.js
// module id = 488
// module chunks = 0 1